import Declined from "./Declined.vue";
import Error from "./Error.vue";
import StepOne from "./StepOne.vue";
import StepTwo from "./StepTwo.vue";
import StepThree from "./StepThree.vue";

export default [
  {
    path: "/",
    redirect: "step-1"
  },
  {
    path: "/step-1",
    name: "step-1",
    component: StepOne
  },
  {
    path: "/step-2",
    name: "step-2",
    component: StepTwo
  },
  {
    path: "/step-3",
    name: "step-3",
    component: StepThree
  },
  {
    path: "/declined",
    name: "declined",
    component: Declined
  },
  {
    path: "/error",
    name: "error",
    component: Error
  },

  // Catch-all route
  {
    path: "*",
    redirect: { name: "step-1" },
  },
];
